module.exports = __webpack_public_path__ + "static/media/plus_icon.b7c444bb.svg";